/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  var activeDetail = event.target.querySelector('.ProductMeta__Details:not([aria-hidden])');
  if (activeDetail) {
    activeDetail.setAttribute('aria-hidden', true);
  }
  var detail = event.target.querySelector('.ProductMeta__Details[data-variant="' + variant.public_title + '"]');
  if (detail) {
    detail.removeAttribute('aria-hidden');
  }
  var imageWrapperElements = event.target.querySelectorAll('.VariantSelector__ImageWrapper'),
      found = false;
  //  console.log(imageWrapperElements);
  //  console.log('warren', image.getAttribute('data-variant-title'), combinationExcludedColor);
  setTimeout( () => {
             var flkty = Flickity.data('.Product__Slideshow');
  //     var node = event.target.querySelector('.Product__Slideshow .Product__SlideItem:not(.is-hidden):not([aria-hidden=true])')
  //     var index = Array.prototype.indexOf.call(node.parentNode.childNodes, node);
  //     flkty.reloadCells();
  //     flkty.select(index);
}, 333);
});

/*
document.addEventListener('product:added', function(event) {
  var variant = event.detail.variant; // Get the variant that was added
  var quantity = event.detail.quantity; // Get the quantity that was added
  var temp_popup = document.querySelector('.hp--upsell-popup');
  if (temp_popup) {
    if (variant.name.includes('Prettier Playmats')) {
      temp_popup.style.display = 'block';
    } else {
      temp_popup.style.display = 'none';
    }
  }
});*/
$(document).ready(function(){
$('.hp--testimonials').slick({
  infinite: true,
  autoplay: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  dots: false, 
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        adaptiveHeight: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ]
});
    
//popup js
$('.ShopTheLook__ViewButton').click(function() {
  $('body').addClass('hp-vacancies-pop');
  $('.hp-vacancies-popup').addClass('is-visible');
});
$('.hp-vacancies-popup .modal-overlay').click(function() {
  $('body').removeClass('hp-vacancies-pop');
  $('.hp-vacancies-popup').removeClass('is-visible');
});
$('.hp-vacancies-popup .modal-close').click(function() {
  $('body').removeClass('hp-vacancies-pop');
  $('.hp-vacancies-popup').removeClass('is-visible');
});
    
});